import { Navigate, Outlet } from "react-router-dom";
import jwtDecode from "jwt-decode";

const OrgPrivateRoute = () => {
  const token = sessionStorage.getItem("token");
  const { isOrg, isSubAdmin } = token
    ? jwtDecode(token)
    : { isOrg: false, isSubAdmin: false };

  return token ? (
    isOrg ? (
      <Outlet />
    ) : isSubAdmin ? (
      <Navigate to="/admin/subdashboard" />
    ) : (
      <Navigate to="/admin/mainDashboard" />
    )
  ) : (
    <Navigate to="/org/login" />
  );
};

export default OrgPrivateRoute;
